export const PHOTO_BOOK_ID = 'PHOTO_BOOK_ID';
export const ADD_PRODUCT_ID = 'ADD_PRODUCT_ID';
export const ADD_FOLDER_ID = 'ADD_FOLDER_ID';
export const ADD_CONTEXT = 'ADD_CONTEXT';
export const LOAD_BOOK_CONTEXT = 'LOAD_BOOK_CONTEXT';
export const ADD_DEFAULT_TEXT = 'ADD_DEFAULT_TEXT';
export const ADD_PARENT_STYLE = 'ADD_PARENT_STYLE';
export const LOAD_PARENT_STYLE = 'LOAD_PARENT_STYLE';




// WEBPACK FOOTER //
// ./src/redux/action-types/bookproperties/index.js